import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Import all blog components
import Blog1 from "../../components/blog/Blog1";
import Blog2 from "../../components/blog/Blog2";
import Blog3 from "../../components/blog/Blog3";
import Blog4 from "../../components/blog/Blog4";
import Blog5 from "../../components/blog/Blog5";

const blogComponentMap = {
  blog1: Blog1,
  blog2: Blog2,
  blog3: Blog3,
  blog4: Blog4,
  blog5: Blog5,
};

const BlogDetailsPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const blogKey = `blog${id}`;
  const c = t(`blog.${blogKey}`, { returnObjects: true });
  const BlogComponent = blogComponentMap[blogKey];

  if (!BlogComponent || !c || !c.title) {
    return <div className="text-center py-12 text-lg">Blog not found.</div>;
  }

  return <BlogComponent content={c} />;
};

export default BlogDetailsPage; 